import { CombinedError } from '@pypestream/api-services/urql';

export type UrqlGqlErrors = {
  errors: NonNullable<CombinedError['networkError'][]>;
};

export const hasErrors = <T>(
  value: T | UrqlGqlErrors | undefined
): value is UrqlGqlErrors => (value as UrqlGqlErrors)?.errors?.length > 0;
